
import {defineComponent} from 'vue'
import moment from 'moment'
import { ReportFilter } from '@/model/models'
import Multiselect from "@vueform/multiselect"

export default defineComponent( {
  name: 'ReportSmallTimeRangeFilter',
  components: { Multiselect },
  props: { filter: ReportFilter },
  data() {
    return {
      selected: 8,
      options: [
        { value: 0, label: 'Last 7 days' },
        { value: 1, label: 'Last 14 days' },
        { value: 2, label: 'Last month' },
        { value: 3, label: 'Last 3 months' },
        { value: 4, label: 'Last 6 months' },
        { value: 5, label: 'Last 12 months' },
        { value: 6, label: 'This year' },
        { value: 7, label: 'Last year' },
        { value: 8, label: 'All time' }
      ]
    }
  },
  emits: ['filter-changed'],
  created() {
    this.onSelect()
  },
  methods: {
    onSelect() {
      const range = this.timeRange
      if (range) {
        this.$emit('filter-changed', { name: this.filter?.name, value: `${range.from},${range.to}` })
      } else {
        this.$emit('filter-changed', { name: this.filter?.name, value: null })
      }
    }
  },
  computed: {
    timeRange() {
      let fromDate = moment().startOf('day')
      let toDate   = moment().endOf('day')

      switch (this.selected) {
        case 0:
          fromDate = moment(fromDate).subtract(7, 'days')
          break
        case 1:
          fromDate = moment(fromDate).subtract(14, 'days')
          break
        case 2:
          fromDate = moment(fromDate).startOf('month').subtract(1, 'month')
          break
        case 3:
          fromDate = moment(fromDate).startOf('month').subtract(3, 'month')
          break
        case 4:
          fromDate = moment(fromDate).startOf('month').subtract(6, 'month')
          break
        case 5:
          fromDate = moment(fromDate).startOf('month').subtract(12, 'month')
          break
        case 6:
          fromDate = moment(fromDate).startOf('year')
          break
        case 7:
          fromDate = moment(fromDate).startOf('year').subtract(1, 'year')
          toDate   = moment(fromDate).endOf('year').subtract(1, 'second')
          break
        case 8:
          return null
      }

      return {
        from: (fromDate.toDate().getTime() / 1000) | 0,
        to:   (toDate.toDate().getTime() / 1000)   | 0
      }
    }
  }
})
